import React from 'react';
import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>How we collect, use, and protect your information</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section">
              <h3>1. Your Privacy Matters</h3>
              <p>
                1WayDoor LLC is committed to securing the privacy of stakeholders connecting
                with us through our website or in business. We intend to make it easier for
                you to understand how we interact with all users by collecting, using, and
                safeguarding their information to avoid any privacy breach when you visit our
                website or enter into a contract with us.
              </p>
              <p>
                Please note that we have all the rights to change the privacy policies at any
                time due to legal obligations and requirements or to safeguard the rights of
                the entity and clients. We will keep you posted with every amendment in this space.
              </p>
            </div>

            <div className="legal-section">
              <h3>2. Personal Information We Collect</h3>
              <p>
                Due to the nature of the services we render, we collect and retain personally
                identifiable information when you fill out the online form or avail the service.
                The information we collect includes:
              </p>
              <ul>
                <li>Name, address, phone number, and email address</li>
                <li>Company name and its details</li>
                <li>Resume, username, password, and security information</li>
                <li>Previous employment information and necessary disclosures</li>
              </ul>
            </div>

            <div className="legal-section">
              <h3>3. Information Collected Automatically</h3>
              <p>As you navigate the website we collect some information automatically:</p>
              <ul>
                <li>Site navigation patterns and page visit frequency</li>
                <li>Device information, carrier, and browser details</li>
                <li>Location information on a city-regional basis</li>
                <li>Referring sites and exit navigation paths</li>
              </ul>
            </div>

            <div className="legal-section">
              <h3>4. How We Use Your Information</h3>
              <p>We use personal information for the following purposes:</p>
              <ul>
                <li>To provide services to clients</li>
                <li>To conduct analytics</li>
                <li>To facilitate inquiries and support requests</li>
                <li>To send marketing and promotional materials (with consent)</li>
                <li>To fulfill legal obligations</li>
                <li>To comply with contractual obligations</li>
                <li>To detect and prevent fraud or illegal activity</li>
                <li>For administrative reasons and relationship management</li>
              </ul>
            </div>

            <div className="legal-section">
              <h3>5. Information Sharing</h3>
              <p>We may share your information in these situations:</p>
              <ul>
                <li>With business affiliates to conduct business operations</li>
                <li>To comply with laws, regulations, and court orders</li>
                <li>With service providers who assist in delivering our services</li>
                <li>For fraud detection and protection of business rights</li>
              </ul>
            </div>

            <div className="legal-section">
              <h3>6. Data Security</h3>
              <p>
                We follow all protocols to safeguard data from loss, theft, destruction, or
                unauthorized access. While we ensure all measures to keep your data safe, we
                cannot guarantee absolute security. In case of any security incident, we will
                notify you as required by law.
              </p>
            </div>

            <div className="legal-section">
              <h3>7. Your Privacy Rights</h3>
              <p>Depending on your jurisdiction, you may have the right to:</p>
              <ul>
                <li>Request details of personal information collected in the last 12 months</li>
                <li>Request a copy of your personal information in a portable format</li>
                <li>Request deletion of your personal information (subject to conditions)</li>
                <li>Be free from discrimination for exercising your privacy rights</li>
              </ul>
            </div>

            <div className="legal-section">
              <h3>8. Cookies</h3>
              <p>
                We use cookies and similar tracking technologies to track activity on our
                website and collect certain information including browser type, time spent,
                pages visited, and language preferences. You can decline cookies through your
                browser settings, though some functionality may be limited.
              </p>
            </div>

            <div className="legal-section">
              <h3>9. Children's Privacy</h3>
              <p>
                We don't intend to collect information from minors. Our services are not meant
                for children under the age of 18. If we become aware of such collection, we
                will take necessary measures to delete the information.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
